// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/upload/upload.js#1 $
'use strict';

angular.module('tcApp')
.directive('tcUpload', function($window, $timeout, $log, tcConstants, SystemRouter, GlobalService, OverlayService) {
	return {
		require: '^ngModel',
		restrict: 'EA',
		templateUrl: 'template/upload/upload.html',
		scope: {
			dataItem: '=ngModel',
			elementId: '@id',
			tcUploadHandler: '&tcUploadHandler',
			tcUploadDefaultImageScaling: '@tcUploadDefaultImageScaling',
			tcUploadSetMessage: '&tcUploadSetMessage',
		},
		link: function(scope, element, attrs, ngModelCtrl) {
			scope.globalStrings = GlobalService.getGlobalStrings();
			var navigator = $window.navigator;
			scope.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || 
				navigator.mozGetUserMedia || navigator.msGetUserMedia;
			if (navigator.mediaDevices) {
				scope.mediaDevices = navigator.mediaDevices;
			}
				
			scope.hasWebcam = angular.isDefined(scope.getUserMedia) || angular.isDefined(scope.mediaDevices);
			
			var fileInputElement = element.find('input')[0];
			var previewElement = angular.element(element[0].querySelector('img.previewSavedImage'))[0];
			var previewNewImgElement = angular.element(element[0].querySelector('img.previewNewImage'))[0];
			
			// displayWebcamElement is used to display webcam video at fixed dimension
			var displayWebcamElement = angular.element(element[0].querySelector('video.displayWebcamVideo'))[0];

			// webcamElement is used to capture and perform resizing
			var webcamElement = angular.element(element[0].querySelector('.uploadWebcamVideo'))[0];
			var canvasElement = angular.element(element[0].querySelector('canvas.uploadCanvas'))[0];
			var context = canvasElement.getContext('2d', {alpha: false});		// alpha off will improve drawing performance
			var originalImageData;		// :ImageData

			scope.viewModel = {
				showImagePreview: false,
				showDocumentLink: false,
				showAttachedMessage: false,
				showWebcam: false,
				hasWebcamPhoto: false,
				hasPhoto: false,
				fileDragActive: false,
				showMultipleFilesMessage: false,
				imageSize: {
					id: 'imageScaling',
					storedValue: '',
					value: '',
					maxWidth: 0,
					maxHeight: 0
				},
				hasMultipleVideoSources: false,
				webcamFacingMode: 'environment',
				filename: '',
				isPreparingImage: false,
			};
			if (angular.isDefined(GlobalService.configuration)
				&& angular.isDefined(GlobalService.configuration.lookup)) {
				scope.viewModel.lookupKeyName = (GlobalService.configuration.lookup.lookupKeyName || 'F6');
			}
			scope.videoStream;
			scope.documentSource;
			
			// watch for changes to the uploaded file
			element.bind('change', function() {
				uploadFile();
			});

			var uploadFile = function() {
				var file = fileInputElement.files[0];
				if (angular.isUndefined(file)) return;

				var filename = file.name;
				scope.viewModel.filename = filename.substring(0,filename.lastIndexOf('.')) || filename;

				if (tcConstants.MIME_TYPE.PREVIEW_TYPES.indexOf(file.type) != -1) {
					$window.loadImage(file, function loadImageCallback(newCanvas) {
						if (newCanvas.type === 'error') {
							scope.tcUploadSetMessage({options: {messageText: scope.globalStrings['XERROR']}});
							$log.error(newCanvas);
							return;
						}
						scope.viewModel.showAttachedMessage = false;
						// Go into 'scaling' mode if a default scaling value is present
						// NOTE: This is intended to maintain backwards compatibility for existing customers
						if (angular.isDefined(scope.tcUploadDefaultImageScaling)) {
							prepareImageToResize(newCanvas, newCanvas.width, newCanvas.height);
						} else {
							// No scaling desired. Immediately commit the file
							newCanvas.toBlob(function(blob) {
								blob.name = (scope.viewModel.filename + '.jpg');
								blob.lastModifiedDate = new Date();
								scope.dataItem.value = blob;
								previewFile();
								fileChangeHandler();
							}, 'image/jpeg');
						}
						
					}, {canvas: true});
				} else {
					scope.dataItem.value = file;
					previewFile();
					fileChangeHandler();
				}
			};
			
			var updateImageElementSrc = function(imageElement, imageBlob) {
				// If the document is an image, we load it in our image tag
				$timeout(function() {
					if ('srcObject' in imageElement) {
						imageElement.srcObject = imageBlob;
					} else {
						// Deprecated in new browsers for media elements
						if (angular.isDefined(imageBlob) && (imageBlob !== '')) {
							imageElement.src = $window.URL.createObjectURL(imageBlob);
						} else {
							var previousImageURL = imageElement.src;
							imageElement.src = '';
							if (previousImageURL !== '') $window.URL.revokeObjectURL(previousImageURL);
						}
					}
				});
			};
			
			var previewFile = function() {
				if (angular.isDefined(scope.dataItem.value)) {
					var type = scope.dataItem.value.type;
					updatePreviewsForType(type);
					if (scope.viewModel.showImagePreview) {
						updateImageElementSrc(previewElement, scope.dataItem.value);
					}
				}
			};

			var camSuccess = function(stream) {
				scope.videoStream = stream;
				if ('srcObject' in webcamElement) {
					displayWebcamElement.srcObject = stream;
					webcamElement.srcObject = stream;
				} else {
					// Deprecated in new browsers
					displayWebcamElement.src = $window.URL.createObjectURL(scope.videoStream);
					webcamElement.src = $window.URL.createObjectURL(scope.videoStream);
				}
				checkVideoSources();
			};

			var camError = function(error) {
				if (error.name === 'PermissionDeniedError') {
					scope.tcUploadSetMessage({options: {messageText: scope.globalStrings['XUPLOADWEBCAMSECURE']}});
				} else if (['NotAllowedError','SecurityError'].indexOf(error.name) !== -1) {
					scope.tcUploadSetMessage({options: {messageText: scope.globalStrings['XUPLOADWEBCAMPERM']}});
				} else {
					scope.tcUploadSetMessage({options: {messageText: scope.globalStrings['XERROR']}});
				}
				$log.error(error);
				$timeout(function() {
					stopWebcam();
					scope.viewModel.showImagePreview = true;
				});
			};

			// Check video sources and allow switching camera if there are multiple sources
			var checkVideoSources = function() {
				if (angular.isUndefined(scope.mediaDevices)) return;
				if (!angular.isFunction(scope.mediaDevices.enumerateDevices)) return;

				scope.mediaDevices.enumerateDevices().then(function countVideoInputs(devices) {
					var videoInputCount = devices.filter(function filterDevices(device) {
						return (device.kind === 'videoinput');
					}).length;
					scope.$apply(function() {
						scope.viewModel.hasMultipleVideoSources = (videoInputCount > 1);
					});
				}).catch(camError);
			};

			var sizeChange = function(str) {
				if (angular.isUndefined(originalImageData)) return;

				var strArr = str.split('^');
				scope.viewModel.imageSize.storedValue = (angular.isDefined(strArr[0]) ? strArr[0] : '');

				switch (scope.viewModel.imageSize.storedValue) {
					case 'Smaller':
						scope.viewModel.imageSize.maxWidth = 640;
						scope.viewModel.imageSize.maxHeight = 480;
						break;
					case 'Small':
						scope.viewModel.imageSize.maxWidth = 800;
						scope.viewModel.imageSize.maxHeight = 600;
						break;
					case 'Medium':
						scope.viewModel.imageSize.maxWidth = 1024;
						scope.viewModel.imageSize.maxHeight = 768;
						break;
					case 'Large':
						scope.viewModel.imageSize.maxWidth = 1280;
						scope.viewModel.imageSize.maxHeight = 1024;
						break;
					case 'Original':
					case '':
						scope.viewModel.imageSize.maxWidth = originalImageData.width;
						scope.viewModel.imageSize.maxHeight = originalImageData.height;
						break;
					default:
						scope.viewModel.imageSize.maxWidth = 200;
						scope.viewModel.imageSize.maxHeight = 160;
				}

				// reset the canvas to the original image
				canvasElement.width = originalImageData.width;
				canvasElement.height = originalImageData.height;
				clearCanvas();
				context.putImageData(originalImageData, 0, 0);

				// get a new canvas element generated from the scaling method
				var newCanvasElement = $window.loadImage.scale(canvasElement, 
					{minWidth: scope.viewModel.imageSize.maxWidth,
					minHeight: scope.viewModel.imageSize.maxHeight,
					maxWidth: scope.viewModel.imageSize.maxWidth,
					maxHeight: scope.viewModel.imageSize.maxHeight});

				// resize the display to accommodate the new image
				canvasElement.width = newCanvasElement.width;
				canvasElement.height = newCanvasElement.height;

				// copy the image data from the new canvas to the display canvas 
				// this will maintain the angular configuration of the display canvas
				context.drawImage(newCanvasElement, 0, 0);
			};

			var startWebcam = function() {
				scope.viewModel.showWebcam = true;
				scope.viewModel.showImagePreview = false;
				updateImageElementSrc(previewNewImgElement, '');
				fileChangeHandler();
				var constraints = {
					video: {
						width: {min: 200, ideal: 1024, max: 1920},
						height: {min: 160, ideal: 768, max: 1080},
						facingMode: scope.viewModel.webcamFacingMode,
					},
					audio: false,
				};

				if (scope.mediaDevices) {
					scope.mediaDevices.getUserMedia(constraints).then(camSuccess).catch(camError);
				} else if (scope.getUserMedia) {
					scope.getUserMedia(constraints, camSuccess, camError);
				}
			};

			var stopWebcam = function() {
				if (angular.isDefined(scope.videoStream)) {
					if (scope.videoStream.stop) {
						scope.videoStream.stop();
					} else {
						angular.forEach(scope.videoStream.getVideoTracks(), function(track) {
							track.stop();
						});
					}
				}
				scope.viewModel.showWebcam = false;
				scope.viewModel.hasWebcamPhoto = false;
				scope.viewModel.hasPhoto = false;
			};
			
			var clearCanvas = function() {
				if (scope.viewModel.showWebcam) {
					context.clearRect(0, 0, webcamElement.videoWidth, webcamElement.videoHeight);
				} else {
					context.clearRect(0, 0, canvasElement.width, canvasElement.height);
				}
			};

			var cancel = function() {
				clearCanvas();
				stopWebcam();
				fileInputElement.value = '';
				scope.viewModel.showImagePreview = true;
				scope.viewModel.isPreparingImage = false;
				fileChangeHandler();
			};

			var prepareImageToResize = function(image, imageWidth, imageHeight) {
				scope.viewModel.isPreparingImage = true;
				canvasElement.width = imageWidth;
				canvasElement.height = imageHeight;
				clearCanvas();
				context.drawImage(image, 0, 0);

				// keep the original data to allow scaling previews
				originalImageData = context.getImageData(0, 0, canvasElement.width, canvasElement.height);

				scope.viewModel.showImagePreview = false;

				if (angular.isDefined(scope.tcUploadDefaultImageScaling)) {
					scope.viewModel.imageSize.value = scope.tcUploadDefaultImageScaling;
				} else {
					scope.viewModel.imageSize.value = 'Original';
				}
				scope.$broadcast('tcLookupContainer:changeValue', scope.viewModel.imageSize);

				scope.viewModel.hasPhoto = true;
				
				// preview image 
				canvasElement.toBlob(function(blob) {
					blob.name = scope.viewModel.filename + '.jpg';
					blob.lastModifiedDate = new Date();
					updateImageElementSrc(previewNewImgElement, blob);
					// Consider this an event to trigger the change handler and pass the updated uploadStatus
					fileChangeHandler();
				}, 'image/jpeg');		
			};
			
			var takePhoto = function() {
				prepareImageToResize(webcamElement, webcamElement.videoWidth, webcamElement.videoHeight);
				scope.viewModel.hasWebcamPhoto = true;
			};

			var openUpload = function() {
				// Clear the current file to allow change handler to trigger for the same filename with different content, or for applying different image scaling
				fileInputElement.value = '';
				$timeout(function fileElementClick() {
					fileInputElement.click();
				});
			};

			var retakePhoto = function() {
				updateImageElementSrc(previewNewImgElement, '');
				clearCanvas();
				scope.viewModel.hasPhoto = false;
				scope.viewModel.hasWebcamPhoto = false;
			};

			var switchCamera = function() {
				scope.viewModel.webcamFacingMode = (scope.viewModel.webcamFacingMode === 'environment' ? 'user' : 'environment');
				stopWebcam();
				startWebcam();
			};
			
			var usePhoto = function() {
				canvasElement.toBlob(function(blob) {
					blob.name = scope.viewModel.filename + '.jpg';
					blob.lastModifiedDate = new Date();
					scope.dataItem.value = blob;
					scope.viewModel.isPreparingImage = false;
					
					clearCanvas();
					stopWebcam();
					previewFile();
					fileChangeHandler();
				}, 'image/jpeg');
			};

			var updatePreviewsForType = function(type) {
				scope.viewModel.showImagePreview = false;
				scope.viewModel.showDocumentLink = false;
				scope.viewModel.showAttachedMessage = false;
				
				if (tcConstants.MIME_TYPE.PREVIEW_TYPES.indexOf(type) != -1) {
					scope.viewModel.showImagePreview = true;
				} else {
					if (scope.dataItem.value === scope.documentSource) {
						// Only allow preview of *existing* documents
						scope.viewModel.showDocumentLink = true;
					} else {
						// Otherwise display a confirmation
						scope.viewModel.showAttachedMessage = true;
					}
				}
			};
			
			var openDocument = function($event) {
				// Only open image types in an overlay
				if (scope.viewModel.showImagePreview) {
					var params = '&DocumentSource=' + previewElement.src;
					OverlayService.open({
						event: $event,
						componentName: 'PAPerson.PhotoOverlay',
						params: params,
					});
				} else {
					GlobalService.openWindow(scope.documentSource, '_blank');
				}
			};
			
			var fileChangeHandler = function() {
				ngModelCtrl.$setDirty();
				// Upload handler can be defined in the component script (e.g. scanning.common.js)
				if (angular.isFunction(scope.tcUploadHandler)) {
					// Trigger after the data item is updated
					var uploadStatus = {
						dataItem: scope.dataItem,
						complete: ((scope.dataItem.value !== '')
							&& !scope.viewModel.showWebcam && !scope.viewModel.isPreparingImage),
					};
					scope.tcUploadHandler({
						uploadStatus: uploadStatus
					});
				}
			};
			
			var toggleFileDragActive = function(fileDragActive) {
				scope.viewModel.fileDragActive = fileDragActive;
			};
			
			var fileDragOver = function(event) {
				if (scope.viewModel.showWebcam || scope.viewModel.isPreparingImage) return;

				event.preventDefault();
				scope.$apply(toggleFileDragActive(true));
				event.dataTransfer.dropEffect = 'move';
			};
			
			var fileDragLeave = function() {
				scope.$apply(toggleFileDragActive(false));
			};

			var fileDrop = function(event) {
				if (scope.viewModel.showWebcam || scope.viewModel.isPreparingImage) return;

				event.preventDefault();
				if ((event.dataTransfer) && (event.dataTransfer.files)) {
					if (event.dataTransfer.files.length > 1) {
						scope.viewModel.showMultipleFilesMessage = true;
					} else {
						scope.viewModel.showMultipleFilesMessage = false;
					}
					scope.$apply(function() {
						try {
							// Chrome allows this and triggers the 'change' event
							fileInputElement.files = event.dataTransfer.files;
							uploadFile();
						} catch (ex) {
							scope.dataItem.value = event.dataTransfer.files[0];
							previewFile();
							fileChangeHandler();
						}
					});
				}
				scope.$apply(toggleFileDragActive(false));
			};
			
			if ((!scope.dataItem.readOnly) && (!scope.dataItem.displayOnly)) {
				element.bind('dragover', fileDragOver);
				element.bind('dragleave', fileDragLeave);
				element.bind('drop', fileDrop);
			}
			
			scope.openUpload = openUpload;
			scope.cancel = cancel;
			scope.startWebcam = startWebcam;
			scope.takePhoto = takePhoto;
			scope.retakePhoto = retakePhoto;
			scope.usePhoto = usePhoto;
			scope.openDocument = openDocument;
			scope.sizeChange = sizeChange;
			scope.switchCamera = switchCamera;

			// If there's an existing document, load it
			if (angular.isDefined(scope.dataItem) && angular.isDefined(scope.dataItem.value) && scope.dataItem.value !== '') {
				// Store the relative link to the existing document
				scope.documentSource = scope.dataItem.value;
				SystemRouter.fetchDocumentMIMEType(scope.documentSource)
				.then(function(type) {
					updatePreviewsForType(type);
					if (scope.viewModel.showImagePreview) {
						// If the document is an image, we load it in our image tag
						previewElement.src = scope.documentSource;
						if (scope.dataItem.tooltip) previewElement.title = scope.dataItem.tooltip;
					}
				});
			}
			
			scope.$on('$destroy', function() {
				element.unbind('dragover', fileDragOver);
				element.unbind('dragleave', fileDragLeave);
				element.unbind('drop', fileDrop);
				stopWebcam();
			});
		},
	};
});
